<template>
  <div>
    <h1>Musafir Orders</h1>

    <GChart type="BarChart" :data="quantityData" :options="quantityOptions" />

    <GChart type="BarChart" :data="salesData" :options="salesOptions" />
  </div>
</template>

<script>
import axios from "axios";
import { GChart } from "vue-google-charts";

export default {
  components: {
    GChart
  },

  data() {
    return {
      quantityData: [],

      quantityOptions: {
        title: "Musafir Orders by Quantity",
        height: 300,
        width: 800
      },

      salesData: [],

      salesOptions: {
        title: "Musafir Orders by Sales",
        height: 300,
        width: 800
      }
    };
  },

  methods: {
    getData() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/reports/specifics", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.allData = res.data;
            // this.columnData = this.allData

            var obj = [];
            var obj2 = [];

            for (let i = 0; i < this.allData.length; i++) {
              let keys = this.allData[i].quantity[0];
              let quantity = this.allData[i].quantity[1];
              let sales = this.allData[i].sales[1];

              keys.unshift("Values");
              quantity.unshift("Quantity");
              sales.unshift("Sales");

              for (let j = 0; j < keys.length; j++) {
                obj[j] = new Array(keys[j], quantity[j]);
                obj2[j] = new Array(keys[j], sales[j]);
              }
            }

            this.quantityData = obj;
            this.salesData = obj2;
          });
      }
    }
  },

  mounted() {
    this.getData();
  }
};
</script>
